// Angular
import { Injectable } from '@angular/core';

// Material library
import { MatDialog } from '@angular/material/dialog';

// Third party
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MatDialogService {

constructor(
  private dialog: MatDialog,
) { }

  /**
   * Open a modal dialog
   * @param {any} component - The component to be opened
   * @param {string} title - The title of the dialog
   * @param {any} payload - The payload of the dialog
   * @param {boolean} actionShowYesBtn - Whether to show the yes button
   * @param {boolean} actionShowNoBtn - Whether to show the no button
   * @returns {Observable<any>} - The observable of the dialog
   */
  open(
    component: any,
    title: string,
    payload: any,
    actionShowYesBtn?: boolean,
    actionShowNoBtn?: boolean,
  ): Observable<any> {
    const dialogRef = this.dialog.open(component, {
      data: { title, payload, actionShowYesBtn, actionShowNoBtn },
      width: '500px',
      disableClose: true,
      autoFocus: false,
      // Material's defaults here run a 150ms enter / 75ms exit
      // animation. Trimming them removes the perceptible lag when the
      // user hits the X / Close on the wager dialogs without losing
      // the visual cue that a dialog is opening / closing.
      enterAnimationDuration: '120ms',
      exitAnimationDuration: '0ms',
      panelClass: title.replace(' ', '-').toLowerCase() + '-modal-dialog'
    });

    return dialogRef.afterClosed();
  }
}
